<script>
  import ToggleSwitch from "../widgets/ToggleSwitch.vue";
  import ModalModelCompetition from "@/components/Competitions/ModalModelCompetition.vue";
  import { mapActions } from "vuex";
  import DropdownOrganism from "../organism/DropdownOrganism.vue";
  import RowCard from "../molecules/rowCard.vue";

  export default {
    data() {
      return {
        rooms: [],
        page: 1,
        cpage: 1,
        isLoading: false,
        totalRooms: null,
        statusFlag: false,
        isMantenience: null,
        columnsContest: {
          tipper: ["NOMBRE", "Ciudad", "Sede", "Tips", "Monitores", "PARTICIPA"],
          monthly: ["NOMBRE", "Ciudad", "Sede", "Monitores", "PARTICIPA"],
          yearly: ["NOMBRE", "Ciudad", "Sede", "Monitores", "PARTICIPA"],
          newbies: ["NOMBRE", "Ciudad", "Sede", "Monitores", "PARTICIPA"],
        },
        head: [],
        modelsSelectList: [],
        currentParticipants: [],
        showModal: false,
        selectedModel: null,
        currentToggle: null,
        tips: 0,
        previousModelsSelectList: [],
        tipsMap: {},
        monitorsMap: {},
      };
    },
    components: { ToggleSwitch, ModalModelCompetition, DropdownOrganism, RowCard },
    props: ["dataModels", "statusRegister", "contest", "monitors"],

    methods: {
      ...mapActions("competitions", ["getCompetitionParticipant", "registerCompetitionParticipant", "removeCompetitionParticipant", "updateParticipant"]),
      async initData() {
        const { participants } = await this.getCompetitionParticipant({ contestId: this.$route.params.id });

        this.currentParticipants = participants;

        if (participants) {
          participants.forEach((element) => {
            this.modelsSelectList.push(element.user._id);
            this.tipsMap[element.user._id] = element.tips || "";
            this.monitorsMap[element.user._id] = element.monitors || [];
          });
        }
      },
      clearData() {
        this.modelsSelectList = [];
        this.tipsMap = {};
        this.monitorsMap = {};
      },
      classHead(item) {
        switch (item) {
          case "":
            return "rooms__item--space";
          case "Comentarios":
            return "rooms__item--comment";
          default:
            return "";
        }
      },
      validateIncludeParticipants(userCheck) {
        if (!this.modelsSelectList.includes(userCheck._id)) {
          this.modelsSelectList.push(userCheck._id);
        }
      },
      check(event, userCheck) {
        const isChecked = event.srcElement.checked;

        const contestId = this.$route.params.id;

        if (!isChecked) {
          let index = this.modelsSelectList.indexOf(userCheck._id);

          if (index !== -1) {
            this.updateParticipant({ body: { tips: "", monitors: [] }, participantId: userCheck._id, contestId });
            this.modelsSelectList.splice(index, 1);

            this.tipsMap[userCheck._id] = "";
            this.monitorsMap[userCheck._id] = [];

            this.removeCompetitionParticipant({ userId: userCheck._id, contestId });
          }

          return;
        }
        this.validateIncludeParticipants(userCheck);
        this.registerCompetitionParticipant({ newUser: { user: userCheck._id }, contestId });
      },
      validateMod(id) {
        return this.modelsSelectList.includes(id) ? { label: "Si", value: true } : { label: "No", value: false };
      },
      async showModalDetails(result) {
        this.showModal = !this.showModal;
        this.selectedModel = result;
      },
      async cancelModalDetails() {
        this.showModal = !this.showModal;
      },
      onChangeTips(event, user) {
        const value = event.target.value;
        const toNumber = Number(value);

        if (isNaN(toNumber)) {
          this.tipsMap[user._id] = "";
          event.target.value = "";
          return;
        }

        this.tipsMap[user._id] = value;

        if (!this.$route.params.id || !user) return;

        this.updateParticipant({ body: { tips: value }, participantId: user._id, contestId: this.$route.params.id });
      },
      sortedTippers() {
        const participantsSorted = [...this.currentParticipants]
          .sort((a, b) => Number(b.tips) - Number(a.tips))
          .map(({ user }) => ({
            ...user,
            tips: this.tipsMap[user._id] || "",
          }));

        const activeIds = new Set(this.currentParticipants.map((p) => p.user._id));

        const inactiveUsers = this.dataModels
          .filter((model) => !activeIds.has(model._id))
          .map((model) => ({
            ...model,
            tips: this.tipsMap[model._id] || "",
          }));

        return [...participantsSorted, ...inactiveUsers];
      },
      handleMonitorChange(monitors, userId) {
        this.updateParticipant({ body: { monitors }, participantId: userId, contestId: this.$route.params.id });
      },
      truncate(str, max = 8) {
        return str.length > max ? str.slice(0, max) + "…" : str;
      },
      getResponsiveUserName(name, _id) {
        const screenWidth = this.$store.state.screen.width;
        const monitorCount = this.monitorsMap[_id]?.length ?? 0;

        if (monitorCount < 3 || screenWidth > 400) {
          return name;
        }

        return this.truncate(name);
      },
    },
    computed: {
      isTipperContest() {
        return this.contest?.type === "tipper";
      },
      dataModel() {
        if (!Array.isArray(this.dataModels)) return [];

        if (this.isTipperContest) this.sortedTippers();

        return this.dataModels.map((model) => ({
          ...model,
          tips: this.tipsMap[model._id] || "",
          monitors: this.monitorsMap[model._id] || [],
        }));
      },
      headColumns() {
        this.head = this.columnsContest[this.contest?.type];
        return this.head;
      },
      isLessThan1024() {
        return this.$store.state.screen.width < 1024;
      },
    },
    async mounted() {
      this.initData();
    },
  };
</script>

<template>
  <div class="rooms" v-if="!statusRegister">
    <div class="rooms__head">
      <div :class="['rooms__item', classHead(item)]" v-for="(item, idx) in headColumns" :key="idx">
        {{ item }}
      </div>
    </div>
    <div class="rooms__container">
      <div v-for="user in dataModel" :key="user._id">
        <div class="rooms__card" v-if="!isLessThan1024">
          <div class="rooms__info">
            <div class="rooms__li rooms__li--name" @click="showModalDetails(user)">
              <span class="mobile">Nombre:</span>
              <div class="rooms__li_avatarC">
                <div class="rooms__li_avatarC--content">
                  <avatar class="rooms__li_avatarC__avatar" :user="user"></avatar>
                </div>
                <p class="__name">
                  {{ user.artisticName }}
                </p>
              </div>
            </div>
            <div class="rooms__li">
              <span class="mobile">Ciudad:</span>
              <span class="rooms__li rooms__li--city">{{ user.city }}</span>
            </div>
            <div class="rooms__li">
              <span class="mobile">Sede:</span>
              <span class="rooms__li rooms__li--sede">{{ user.office }}</span>
            </div>
            <div class="rooms__li" v-if="isTipperContest">
              <input
                v-if="!isLessThan1024"
                @input="(event) => onChangeTips(event, user)"
                :value="tipsMap[user._id] || ''"
                type="text"
                class="rooms__input"
                inputmode="numeric"
                pattern="\d*"
                placeholder="0"
                maxlength="7"
                :disabled="!modelsSelectList.includes(user._id)" />
            </div>
            <div class="rooms__li">
              <DropdownOrganism
                v-if="!isLessThan1024"
                :list="monitors[0].users"
                placeholder="Añade el monitor"
                :value="monitorsMap[user._id] || []"
                :itemId="user._id"
                @input="handleMonitorChange"
                :currentItem="user"
                :disabled="!modelsSelectList.includes(user._id)" />
            </div>
            <div class="rooms__li rooms__li--toggle" v-if="contest?.rankingMode !== 'automatic'">
              <span class="mobile">Participa:</span>
              <div class="rooms__li--toggle--label">
                <span class="answer">
                  {{ validateMod(user._id).label }}
                </span>
                <ToggleSwitch :checked="validateMod(user._id)['value']" @change="check($event, user)" ref="toggle" class="switch" />
              </div>
            </div>
          </div>
        </div>
        <div class="rooms__infoMobile" v-else="isLessThan1024">
          <div class="rooms__topRow">
            <div class="rooms__li_avatarC">
              <avatar class="rooms__li_avatarC__avatar" :user="user" />
              <div class="rooms__nameBlock">
                <p class="__name">{{ user.artisticName }}</p>
                <p class="__city">{{ user.city }} - {{ user.office }}</p>
              </div>
            </div>
            <ToggleSwitch :checked="validateMod(user._id).value" @change="check($event, user)" class="switch" />
          </div>
          <div class="rooms__li--mobileTips" v-if="isTipperContest && user.tips">
            <span class="mobile">Tips:</span>
            <span class="rooms__tipsValue">{{ user.tips }}</span>
          </div>
          <div v-if="monitorsMap[user._id]?.length" class="rooms__li--mobileMonitor">
            <span class="mobile">Monitor:</span>
            <div class="rooms__list">
              <RowCard
                class="rooms__item"
                v-for="(monitor, index) in monitorsMap[user._id]"
                :key="index"
                :item="monitor"
                :title="index === 0 ? getResponsiveUserName(monitor.user, user._id) : ''"
                :img="monitor.picture"
                :tooltipText="monitor.user"
                :showIcon="false"
                :canShowTooltip="index !== 0"
                :showBackground="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="spinner" v-if="isLoading"></div>
    <ModalModelCompetition v-if="showModal" @close="showModalDetails()" @calncel="cancelModalDetails()" :participant="selectedModel" :participantsList="currentParticipants" />
  </div>
  <div v-else>
    <div class="rooms__notRegister">
      <span class="rooms__notRegister_label">Ingrese el nombre del concurso para iniciar.</span>
    </div>
  </div>
</template>

<style lang="scss">
  .rooms {
    border-radius: 12px;
    background: #fff;
    margin-top: 25px;
    &__notRegister {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 400px;
      color: $primary;
      font-weight: 800;
    }

    .activeBtn {
      display: none;
    }

    &__card {
      margin: 0 auto;
      background-color: $white;
      box-shadow: 0 2px 5px $alto;
      padding: 0;
      font-size: 14px;
      border-bottom: 1px solid #e5e5e5;
    }

    &__head {
      display: none;
    }

    &__info {
      display: block;
      padding: $mpadding;

      &:hover {
        color: $primary;
        transition: 0.4s;

        &--name {
          color: $primary;
          transition: 0.4s;
          cursor: pointer;
        }
      }
    }

    .mobile {
      font-weight: bold;
    }

    &__li {
      display: flex;
      margin: 1px;
      justify-content: space-between;

      &--room {
        color: $lipstick;
        font-weight: bold;
      }

      &--toggle {
        margin-bottom: 10px;
        align-items: center;

        &--label {
          display: flex;

          span {
            margin-right: 5px;
            width: 20px;
          }
        }
      }

      &_avatarC {
        display: flex;
        align-items: center;
        width: 100%;

        &--content {
          width: 30%;
        }

        &__avatar {
          width: 35px;
          height: 35px;
          border: 2px solid $primary-color;
        }

        .__name {
          padding-left: 5px;
          width: 110px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    &__btn {
      display: flex;
    }

    &__saved {
      margin: 0 auto;
      border: none;
      padding: 3px $mpadding/2;
      background-color: $lipstick;
      color: $white;
      border-radius: 5px;

      &:focus {
        outline: none;
      }

      &:active {
        transform: scale(0.97);
      }

      &:hover {
        opacity: $opacity-button;
      }
    }

    .textarea {
      min-height: 52px;
      max-height: 52px;
      max-width: 241px;
      margin-bottom: 10px;
      overflow-y: auto;
      border: 1px solid $alto;
      border-radius: 5px;
      font-size: 13px;
      padding: 7px 5px;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        width: 0px;
        height: 0px;
        -ms-overflow-style: none;
        overflow: -moz-scrollbars-none;
      }

      &:focus {
        outline: none;
      }
    }
    &__input {
      display: flex;
      height: 37px;
      padding: 8px 8px 8px 11px;
      justify-content: flex-end;
      align-items: center;
      border-radius: 8px;
      border: 1px solid #e0e0e0;
      width: 110px;
      text-align: end;
      z-index: 10;
      &:focus {
        border: 1px solid #adadad;
      }
    }
    &__infoMobile {
      display: flex;
      flex-direction: column;
      border-radius: 12px;
      padding: 12px;
      margin-bottom: 10px;
      background: #f5f5f5;
    }

    &__topRow {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
    }

    &__nameBlock {
      @include Flex(column);
      .__name {
        font-size: 16px;
        font-weight: bold;
        color: #000;
      }
      .__city {
        font-size: 14px;
        color: #555;
      }
    }
    .switch {
      transform: scale(0.9);
    }
    &__li--mobileTips {
      @include Flex(row, space-between);
      margin-top: 8px;
      font-weight: bold;
    }
    &__value {
      margin-left: 8px;
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }
    &__li--mobileMonitor {
      margin-top: 10px;
      .mobile {
        font-weight: bold;
        margin-bottom: 4px;
      }
    }
    &__list {
      display: flex;
      gap: 2px;
    }
    &__item {
      width: auto;
    }
  }
  @media (min-width: 1024px) {
    .rooms {
      border: 1px solid #dadada;
      .mobile {
        display: none;
      }

      &__card {
        font-size: 16px;
        height: 70px;
      }

      &__head {
        display: flex;
        margin: 0 auto;
        border: 5px 5px;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        background: rgba(109, 111, 128, 0.08);
        border-bottom: 1px solid #e5e5e5;
        padding: $mpadding/2 $mpadding * 2;
        font-weight: bold;
        height: 50px;
        align-items: center;
      }

      &__item {
        width: 14.8%;

        text-transform: uppercase;
        font-weight: 800;

        &--space {
          width: 10%;
        }

        &--comment {
          width: 30%;
        }

        &:last-child {
          width: 27%;

          text-align: end;
        }
      }

      &__info {
        display: flex;
        justify-content: space-around;
        padding: 0 $mpadding * 2;
        height: 100%;
      }

      &__comment {
        width: 30%;
      }

      &__li {
        display: flex;
        align-items: center;
        width: 29%;
        margin: 0 1px;

        &--toggle {
          width: 30%;
          display: flex;
          justify-content: end;
          margin: 0 auto;
        }
      }

      &__btn {
        display: inline;
        width: 10%;
      }

      &__saved {
        margin-left: 30px;
      }

      .textarea {
        min-height: 32px;
        max-height: 32px;
        margin-bottom: 0;
        width: 100%;
      }
    }
  }
</style>
